export default __webpack_public_path__ + "static/media/star_fill.0c202568.svg";